import styled from 'styled-components';

// Dependencies
import { Link } from 'react-router-dom';

// Components
import { Typography } from '../../display/Typography';
import { MainButton } from '../../inputs/buttons/MainButton';

export const ContainerForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const Title = styled(Typography)`
  font-size: 2.4rem;
  margin-bottom: 2.5rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    font-size: 1.8rem;
    margin-bottom: 1.8rem;
  }
`;

export const Infotext = styled(Typography)`
  margin-top: 1rem;
  margin-bottom: 2rem;
  width: 100%;
  text-align: justify;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.greySoftLight};
  line-height: 1.4;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    font-size: 0.9rem;
    margin-bottom: 1.2rem;
  }
`;

export const PasswordButton = styled(MainButton)`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  width: 100%;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    margin-top: 1.5rem;
    margin-bottom: 1.2rem;
    padding: 1.7rem;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    margin-top: 1.2rem;
    margin-bottom: 1rem;
  }
`;

export const LinkPolicy = styled(Link)`
  text-decoration: none;
`;

export const ArrowBackLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  flex-shrink: 0;

  img {
    width: 1.6rem;
    height: 1.2rem;
  }
`;

export const ContainerOra = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 2.2rem;
  gap: 1rem;

  @media (max-width: 1024px) {
    margin-bottom: 2rem;
  }
  @media (max-width: 768px) {
    margin-bottom: 1.8rem;
    gap: 0.8rem;
  }
  @media (max-width: 600px) {
    margin-bottom: 1.5rem;
    gap: 0.6rem;
  }
  @media (max-width: 480px) {
    margin-bottom: 1.2rem;
    gap: 0.5rem;
  }
`;

export const OraLogo = styled.img`
  width: 11rem;
  height: 3.236rem;

  @media (max-width: 1024px) {
    width: 10rem;
    height: 2.94rem;
  }
  @media (max-width: 768px) {
    width: 9rem;
    height: 2.65rem;
  }
  @media (max-width: 600px) {
    width: 8rem;
    height: 2.35rem;
  }
  @media (max-width: 480px) {
    width: 7rem;
    height: 2.06rem;
  }
`;
